import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';

export type ServiceDeskMappingKey =
	| 'major-incident-field'
	| 'change-type-field'
	// following keys are not used
	| 'affected-services'
	| 'approvers-field'
	| 'backout-plan-field'
	| 'change-completion-date-field'
	| 'change-reason-field'
	| 'change-risk-field'
	| 'change-start-date-field'
	| 'impact-field'
	| 'implementation-plan-field'
	| 'planned-end-date-field'
	| 'planned-start-date-field'
	| 'responders-field'
	| 'test-plan-field'
	| 'urgency-field'
	| 'vp-origin';

export type ServiceDeskCustomField = {
	id: string;
	primaryJQLClauseName: string;
};

export type ServiceDeskCustomFields = Partial<
	Record<ServiceDeskMappingKey, ServiceDeskCustomField>
>;

type ServiceDeskFieldsResponse = {
	customFields: { id: string; mappingKey: ServiceDeskMappingKey; primaryJQLClauseName: string }[];
};

const ENDPOINT = '/rest/servicedesk/1/servicedesk/fields';

export const eocServicedeskCustomFieldsResource: RouteResource<ServiceDeskCustomFields> =
	createResource({
		type: 'EOC_SERVICEDESK_CUSTOM_FIELDS',
		getKey: () => 'eoc-servicedesk-custom-fields',
		getData: async () => {
			try {
				const response = await performGetRequest<ServiceDeskFieldsResponse>(ENDPOINT);
				const customFields: ServiceDeskCustomFields = Object.fromEntries(
					response.customFields.map((field) => [
						field.mappingKey,
						{ id: field.id, primaryJQLClauseName: field.primaryJQLClauseName },
					]),
				);
				return customFields;
			} catch {
				// Pages should still load even if this request fails, so swallow errors and return an empty mapping.
				return {};
			}
		},
	});
